import request from '@/utils/request';

/**
 * * * 智能客服
 */

//智能语料库-新增语料库
export function insertIntelligentCorpus(data) {
  return request({
    url: 'insertIntelligentCorpus',
    method: 'post',
    data: data
  });
}

//智能语料库-删除语料库
export function deleteIntelligentCorpus(params) {
  return request({
    url: 'deleteIntelligentCorpus',
    method: 'get',
    params: params
  });
}

//智能语料库-更新语料库
export function updateIntelligentCorpus(data) {
  return request({
    url: 'updateIntelligentCorpus',
    method: 'post',
    data: data
  });
}

//智能语料库-列表查询
export function getIntelligentCorpusList(params) {
  return request({
    url: 'getIntelligentCorpusList',
    method: 'get',
    params: params
  });
}

//公众号-后台管理员-获取会话列表
export function getConversationList(params) {
  return request({
    url: 'getConversationList',
    method: 'get',
    params: params
  });
}

//公众号-后台管理员-获取会话详情
export function getNotificationDetails(data) {
  return request({
    url: 'getNotificationDetails',
    method: 'post',
    data: data
  });
}

//公众号-后台管理员-获取会话内容列表
export function getConversationContentList(data) {
  return request({
    url: 'getAdminConversationContentList',
    method: 'post',
    data: data
  });
}

//公众号-后台管理员-获取家长绑定的学生列表
export function insertCustomerServiceAnswer(data) {
  return request({
    url: 'insertCustomerServiceAnswer',
    method: 'get',
    params: data
  });
}

//公众号-后台管理员-客服回答
export function getParentsBoundStudentList(data) {
  return request({
    url: 'getParentsBoundStudentList',
    method: 'post',
    data: data
  });
}

//公众号-后台管理员-检查会话是否更新
export function getIsUpdateTime(params) {
  return request({
    url: 'getIsUpdateTime',
    method: 'get',
    params: params
  });
}
export function selectUserAnswerList(params) {
  return request({
    url: 'selectUserAnswerList',
    method: 'get',
    params: params
  });
}
export function createUserAnswer(params) {
  return request({
    url: 'createUserAnswer',
    method: 'get',
    params: params
  });
}
export function updateUserAnswer(params) {
  return request({
    url: 'updateUserAnswer',
    method: 'get',
    params: params
  });
}
export function deleteUserAnswerDetails(params) {
  return request({
    url: 'deleteUserAnswerDetails',
    method: 'get',
    params: params
  });
}